import * as yup from "yup";
import { createAddressFields } from "../constants";
import { type FormSectionConfig, type TaxFormConfig } from "../types";

const sections: FormSectionConfig[] = [
  {
    id: "identification",
    title: "Identification of Beneficial Owner",
    fields: [
      {
        name: "name",
        type: "text",
        label: "Name",
        placeholder: "",
        required: true,
        gridColumn: "half",
      },
      {
        name: "countryOfCitizenship",
        type: "country",
        label: "Country of citizenship",
        placeholder: "Select a country",
        required: true,
        gridColumn: "half",
      },
      {
        name: "_permanentAddressLabel",
        type: "label",
        label: "Permanent residence address",
        required: true,
        linkedField: "permanentAddress",
        gridColumn: "full",
      },
      ...createAddressFields("permanentAddress", {
        helpText: "Do not use a P.O. box or in-care-of address",
      }),
      {
        name: "usTin",
        type: "text",
        label: "US TIN",
        gridColumn: "half",
      },
      {
        name: "foreignTin",
        type: "text",
        label: "Foreign TIN",
        gridColumn: "half",
      },
      {
        name: "_ftinSpacer",
        type: "label",
        label: "",
        gridColumn: "half",
      },
      {
        name: "ftinNotLegallyRequired",
        type: "checkbox",
        label: "Check if FTIN not legally required",
        gridColumn: "half",
      },
      {
        name: "dateOfBirth",
        type: "date",
        label: "Date of birth",
        required: true,
        gridColumn: "half",
      },
    ],
  },
  {
    id: "treatyBenefits",
    title: "Claim of Tax Treaty Benefits",
    fields: [
      {
        name: "treatyCountry",
        type: "country",
        label: "Treaty country",
        placeholder: "Select a country",
        gridColumn: "half",
      },
      {
        name: "_treatyCountrySpacer",
        type: "label",
        label: "",
        gridColumn: "half",
      },
      {
        name: "treatyRateClaimed",
        type: "percentage",
        label: "Treaty rate claimed",
        placeholder: "Enter percentage",
        gridColumn: "half",
      },
      {
        name: "incomeType",
        type: "text",
        label: "Income type",
        placeholder: "Specify type of income",
        gridColumn: "half",
      },
    ],
  },
];

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  countryOfCitizenship: yup.string().required("Country of citizenship is required"),
  permanentAddress: yup.object().shape({
    country: yup.string().required("Country is required"),
    streetLine1: yup.string().required("Street (line 1) is required"),
    city: yup.string().required("City is required"),
    zipCode: yup.string().required("Zip code is required"),
  }),
  dateOfBirth: yup.date().nullable().required("Date of birth is required"),
});

const initialValues = {
  name: "",
  countryOfCitizenship: "",
  permanentAddress: {
    country: "",
    streetLine1: "",
    streetLine2: "",
    city: "",
    stateOrProvince: "",
    zipCode: "",
  },
  usTin: "",
  foreignTin: "",
  ftinNotLegallyRequired: false,
  dateOfBirth: null,
  treatyCountry: "",
  treatyRateClaimed: "",
  incomeType: "",
};

export const w8benConfig: TaxFormConfig = {
  formId: "W8BEN",
  title: "New FATCA details",
  subtitle: "W-8BEN",
  sections,
  validationSchema,
  initialValues,
};
